<template>
  <ul>
    <li class="job_item" v-for="(item) in jobs" :key="item.jobId" @click="$emit('changeSelect', item.jobId)">
      <!-- <el-row> -->
        <el-row>
          <el-col :span="12"><span class="font30">{{item.postName}}</span></el-col>
          <el-col :span="12" class="text-right">
            <el-link type="primary" :underline="false">选择</el-link>
          </el-col>
        </el-row>
        <el-row>
          <el-icon class="el-icon-location-outline" style="color:#1896ff" /> {{item.postCity}}</el-row>
        <el-row>发布时间：{{$Shared.formatDate(item.refreshDate)}}</el-row>
      <!-- </el-row> -->
    </li>
  </ul>
</template>

<script>
  import {
    getMyNormalList
  } from '~/api/job';
  export default {
    data() {
      return {
        jobs: [],
      };
    },
    created() {
      this.getList();
    },
    methods: {
      getList() {
        getMyNormalList().then(m => {
          if (m.errcode == 0) {
            this.jobs = m.data;
          }
        });
      },
    }
  };
</script>

<style scoped>
  .job_item {
    cursor: pointer;
    margin-top: 6px;
    padding: 8px;
    border: #ebedf0 1px solid;
    border-radius: 3px;
    background: #fff;
    line-height: 24px;
  }
</style>